<div class="col-md-12">
  <div class="row-no-margin">
    <span class="popup-header">RMA Response</span>
  </div>
  <div class="row-no-margin" style="padding:10px;">
    <div class="row-no-margin col-md-12">
      <div class="col-md-4">
        <input type="radio" name="ResponseAction" [(ngModel)]="Response.Action" id="ResponseAction_Rpr" value="Rpr" />
        <label for="ResponseAction_Rpr">Repair per quote</label>
      </div>
      <div class="col-md-4">
        <input type="radio" name="ResponseAction" [(ngModel)]="Response.Action" id="ResponseAction_return" value="return" />
        <label for="ResponseAction_return">Return as is</label>
      </div>
      <div class="col-md-4">
        <input type="radio" name="ResponseAction" [(ngModel)]="Response.Action" id="ResponseAction_scrap" value="scrap" />
        <label for="ResponseAction_scrap">Scrap</label>
      </div>
      <!--<div class="col-md-3">
        <input type="radio" name="ResponseAction" [(ngModel)]="Response.Action" id="ResponseAction_other" value="other" />
        <label for="ResponseAction_other">Other</label>
      </div>-->
    </div>
    </div>
  <div class="row-no-margin">
    <div class="col-md-3">
      <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
        <mat-label>Purchase Order #</mat-label>
        <input matInput class="mat-focused" [(ngModel)]="Response.PONumber" id="txtDescription" />
      </mat-form-field>
      
    </div>
    <div class="col-md-3">
      <span [hidden]="HidePOValidation">Please enter a PO #</span>
    </div>
  </div>
  <div class="row-no-margin" style="padding-top:10px;" [hidden]="Response.Action != 'Rpr'">
    <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload />
    <div class="col-md-8" style="padding-bottom:21px;">
      {{Response.POFileName || "No file uploaded yet."}}
      <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUpload.click()">
        <mat-icon>attach_file</mat-icon>
      </button>
    </div>
  </div>
  <div class="row-no-margin">
    <span class="popup-sub-header">Comments</span>
  </div>
    <div class="row-no-margin col-md-12 justify-content-center">

      <textarea cols="100" rows="8" [(ngModel)]="Response.CustomerResponse"></textarea>
    </div>
    <!--<div class="row-no-margin">
      <div class="col-md-12 justify-content-center">
        <button class="blue" (click)="SubmitResponse()">Submit</button>
      </div>
    </div>-->
  </div>
